<template>
  <div class="content-container">
    <div class="bg-container">
    <h1 class="primary-text text-h3">Pflegehilfsmittel im Wert von 40€ pro Monat GRATIS sichern</h1>
    <h2 class="text-h5 text-center">Sie haben einen Pflegegrad? Dann sichern Sie sich jetzt Ihren Anspruch auf kostenlose Pflegehilfsmittel. Wir übernehmen den kompletten Antragsprozess und klären alles Weitere mit Ihrer Pflegekasse.</h2>

    <v-row class="mt-4 mb-16">
        <!-- Linke Spalte mit Buttons nebeneinander -->
        <v-col cols="12" md="6"  class="d-flex flex-column justify-center align-center">

          <h2 id="pflegegrad" class="primary-text mb-4 align-center text-h4">Haben Sie ein Pflegegrad?</h2>

          <div class="d-flex justify-center align-center w-100" style="padding: 40px;">
            <v-btn
                @click="$router.push('/pflegegrad_bestimmen')"
                large
                color="gradient-primary"
                class="elevation-0"
                @mouseover="elevateButton"
                @mouseleave="deElevateButton"
                style="width: 100%; height: 300px; font-size: 40px; margin-right: 1%;"
            >
              <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
                <v-icon xx-large style="font-size: 80px">mdi-thumb-up</v-icon>
                <span class="mt-4">Ja</span>
              </div>
            </v-btn>

            <v-btn
                @click="toggleModal"
                large
                class="elevation-0"
                @mouseover="elevateButton"
                @mouseleave="deElevateButton"
                color="gradient-primary"
                style="width: 100%; height: 300px; font-size: 40px; margin-left: 1%;"
            >
              <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
                <v-icon xx-large style="font-size: 80px">mdi-thumb-down</v-icon>
                <span class="mt-4">Nein</span>
              </div>
            </v-btn>
          </div>

          <div class="usps">
            <v-row class="usp" v-for="usp in usps" :key="usp.text">
              <v-col cols="12" class="d-flex flex-column align-center">
                <img :src="usp.icon" alt="Icon" class="usp-icon">
                <span class="usp-text">{{ usp.text }}</span>
                <span class="usp-subtext">{{ usp.subtext }}</span> <!-- Neuer Subtext -->
              </v-col>
            </v-row>
          </div>

        </v-col>





      <!-- Rechte Spalte mit Bild -->
      <v-col cols="12" md="6">
        <v-img
            :src="'https://img.freepik.com/fotos-kostenlos/caregiver-draengen-aeltere-frau-im-rollstuhl_1098-3013.jpg?w=1380&t=st=1695163485~exp=1695164085~hmac=0dee025fb607ede61f40898fccd345a1c3d60a677ab2ee982410a7c8f46f1353'"
            height="100%"
            width="100%"
            contain
        ></v-img>
      </v-col>
    </v-row>

    <v-dialog v-model="showModal" max-width="600">
      <v-card>
        <v-card-title class="primary-text text-center text-h4">Information</v-card-title>
        <v-card-text class="text-center text-h5">
          Vielen Dank für Ihr Interesse.
          <br>
          Da Sie keinen Pflegegrad haben, können wir Ihnen aktuell leider kein Angebot machen.
          <br>
          Sollte sich dies ändern, können Sie gerne wieder auf uns zurückkommen.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showModal = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

    <div class="testimonials-container">
      <v-row>
        <v-col cols="3" v-for="(testimonial, index) in testimonials" :key="index">
          <div class="testimonial">
            <div class="testimonial-stars">
              <v-icon v-for="star in 5" :key="star" :color="star <= testimonial.rating ? 'gold' : 'grey'">mdi-star</v-icon>
            </div>
            <p class="testimonial-text flex-grow">{{ testimonial.text }}</p>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <!-- Linke Spalte (40%): Bild -->
      <v-col cols="12" md="6">
        <v-img
            :src="'https://www.docdorado.de/media/2f/ea/20/1695928808/istockphoto-1411235353-1024x1024.jpg'"
            height="100%"
            width="100%"
        ></v-img>
      </v-col>

      <v-col cols="12" md="6" class="mt-16 pa-16"> <!-- Py-3 fügt vertikales Padding hinzu -->
        <!-- Überschrift -->
        <h2 class="primary-color">In 3 einfachen Schritten zu kostenlosen Pflegehilfsmitteln</h2>

        <!-- Schritt 1 -->
        <div class="step d-flex align-center mt-3">
          <v-icon class="primary-color" large>mdi-checkbox-marked-circle-outline</v-icon>
          <div class="step-content">
            <h3 class="primary-color">Pflegehilfsmittel auswählen</h3>
            <p>Wählen Sie die passenden Produkte für sich aus</p>
          </div>
        </div>

        <!-- Schritt 2 -->
        <div class="step d-flex align-center mt-3">
          <v-icon class="primary-color" large>mdi-timer-sand</v-icon>
          <div class="step-content">
            <h3 class="primary-color">Fragen beantworten</h3>
            <p>Dauert nicht länger als 5 Minuten ⚡</p>
          </div>
        </div>

        <!-- Schritt 3 -->
        <div class="step d-flex align-center mt-3">
          <v-icon class="primary-color" large>mdi-gift-outline</v-icon>
          <div class="step-content">
            <h3 class="primary-color">Pflegehilfsmittel kostenlos erhalten</h3>
            <p>Erhalten Sie monatlich Ihre 100% kostenlosen Pflegehilfsmittel bequem nach Hause</p>
          </div>
        </div>

        <div class="text-center my-4"> <!-- my-4 fügt vertikales Padding für Abstand hinzu -->
          <v-btn color="homeButton" href="#pflegegrad" class="white--text" x-large>Pflegehilfsmittel beantragen</v-btn>
        </div>


      </v-col>
    </v-row>


    <div id="exitModal" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); z-index: 1000; align-items: center; justify-content: center;">
      <div style="width: 600px; padding: 20px; background: #fff; position: relative;">
        <span class="close-modal" @click="closeModal" style="font-size: 24px; color: #333; position: absolute; top: 10px; right: 10px; cursor: pointer;">×</span>


        <v-row>
          <v-col cols="8">
            <h2 style="text-align: center;">Sind Sie sich sicher, dass Sie keine kostenlosen Pflegehilfsmittel beantragen möchten?</h2>
            <p style="text-align: center;">Gesetzlicher Anspruch ab Pflegegrad 1</p>
            <p style="text-align: center; font-weight: bold;">Liegt ein Pflegegrad vor?</p>

            <v-row>
              <v-col cols="6">
                <v-btn
                    @click="$router.push('/pflegegrad_bestimmen')"
                    color="gradient-primary"
                    class="elevation-0"
                    @mouseover="elevateButton"
                    @mouseleave="deElevateButton"
                    style="width: 100%; font-size: 20px; height: 60px;">
                  <div class="d-flex flex-column align-center justify-center" style="width: 100%;">
                    <v-icon large>mdi-thumb-up</v-icon>
                    <span>Ja</span>
                  </div>
                </v-btn>
              </v-col>

              <v-col cols="6">
                <v-btn
                    @click="closeAndToggle"
                    class="elevation-0"
                    @mouseover="elevateButton"
                    @mouseleave="deElevateButton"
                    color="gradient-primary"
                    style="width: 100%; font-size: 20px; height: 60px;">
                  <div class="d-flex flex-column align-center justify-center" style="width: 100%;">
                    <v-icon large>mdi-thumb-down</v-icon>
                    <span>Nein</span>
                  </div>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="4" class="d-flex align-center justify-center">
            <img src="https://www.docdorado.de/media/ed/89/a3/1695931488/istockphoto-587508292-1024x1024.jpg" alt="Bild" style="max-width: 100%;">
          </v-col>
        </v-row>
      </div>
    </div>



  </div>

</template>

<script>

export default {
  name: 'MyComponent',
  data() {
    return {
      modalShown: false,
      usps: [
        { icon: 'https://www.docdorado.de/media/48/0a/2c/1695899143/versand-100.png', text: 'Gratis Versand', subtext: 'Innerhalb von Deutschland' },
        { icon: 'https://www.docdorado.de/media/77/65/d8/1695899143/schild-64.png', text: 'Zuverlässige monatliche Lieferung', subtext: 'Ohne Unterbrechungen' },
        { icon: 'https://www.docdorado.de/media/21/9e/fd/1695899143/no-money-64.png', text: 'Keine Bürokratie', subtext: 'Kein Papierkram' },
        { icon: 'https://www.docdorado.de/media/f0/0a/2b/1695899143/archive-53.png', text: 'Ohne Zuzahlung', subtext: 'Volle Kostenübernahme' },
      ],
      testimonials: [
        { rating: 5, text: "Wir erhalten nun schon seit langem die Pflegebox für unsere Oma und wir sind sehr zufrieden damit. Auch der Wechsel zu hysana war einfach und unkompliziert. Alles Super!!!" },
        { rating: 5, text: "Immer pünktliche Lieferung und Änderungen an der Pflegebox sind einfach und unkompliziert. Weiter so Liebes Hysana Team !!!" },
        { rating: 4, text: "Die Bestellung und die Lieferung der Pflegebox ging schnell und unkompliziert. Der Support konnte mir bei all meinen Fragen schnell helfen. Gerne wieder." },
        { rating: 5, text: "Hat meiner Oma im Alltag sehr geholfen und uns dabei, sie nicht so schnell weg geben zu müssen." },
        ],
      showModal: false
    };
  },
  methods: {
    closeAndToggle() {
      this.closeModal();
      this.toggleModal();
    },
    showExitModal() {
      const exitModal = document.getElementById('exitModal');
      if (exitModal) {
        exitModal.style.display = 'flex';
      }
    },
    onMouseLeave(e) {
      if (!this.modalShown) {
        if (e.clientY < 0) {
          this.showExitModal();
          this.modalShown = true;
        }
      }
    },
    closeModal() {
      document.getElementById('exitModal').style.display = 'none';
    },
    leavePage() {
      this.closeModal();
    },
    elevateButton(event) {
      event.currentTarget.classList.remove('elevation-0');
      event.currentTarget.classList.add('elevation-5'); // oder eine andere Zahl je nach gewünschter Schattenstärke
    },
    deElevateButton(event) {
      event.currentTarget.classList.remove('elevation-5');
      event.currentTarget.classList.add('elevation-0');
    },
    toggleModal() {
      this.showModal = !this.showModal;
    }
  },
  mounted() {
    document.addEventListener('mouseleave', this.onMouseLeave);
  },
  beforeDestroy() {
    document.removeEventListener('mouseleave', this.onMouseLeave);
  },
}
</script>

<style scoped>




.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bg-container{
  background-color: #f5f5f5;
  padding: 20px;
}

.primary-text {
  color: var(--v-primary-base); /* Ihre primäre Farbe aus Vuetify */
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}



.usps {
  display: flex;
  justify-content: space-between;
  padding: 0px 0; /* Erhöht von 40px auf 60px */
  width: 100%;

}

.usp {
  display: flex;
  align-items: center;
  gap: 120px; /* Erhöht von 80px auf 120px */
  margin-bottom: 30px; /* Hinzugefügt, um den Abstand zum nächsten Icon zu erhöhen */
}

.usp-icon {
  width: 50px;   /* Größere Icon-Größe */
  height: auto;
  margin-bottom: 10px;
}

.usp-text {
  font-weight: bold;
  margin-bottom: 5px;
}

.usp-subtext {
  font-size: 1.0rem;
  color: #777; /* Ein etwas dunklerer Grauton für den Subtext */
}

.gradient-primary {
  background: linear-gradient(315deg, #f9ad18, #f98918 80%);
  color: white; /* Setzen Sie eine Farbe für den Text, die gut mit dem Gradienten harmoniert */
}

.testimonials-container {
  width: 100%;
  padding-top: 60px;
  background-color: #358f94 !important;
}

.testimonial {
  background-color: #358f94;
  display: flex;
  flex-direction: column; /* Verwendung von Flexbox */
  height: 100%; /* Stellen Sie sicher, dass die Karten den gesamten verfügbaren Raum ausfüllen */
  padding: 20px;
  margin-bottom: 20px;
}

.testimonial-stars {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.testimonial-text {
  color: white;
  font-style: italic;
  text-align: center;
  flex-grow: 1; /* Dies bewirkt, dass der Testimonial-Text den verfügbaren Platz in der Karte ausfüllt */
}

.primary-color {
  color: var(--v-primary-base);
}

.step {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.step-content {
  margin-left: 20px;
}

h3 {
  font-size: 20px;
  margin-bottom: 5px;
}

.close-modal {
  position: absolute;
  right: 10px;       /* Abstand von rechts */
  top: 10px;         /* Abstand von oben */
  font-size: 1.5rem; /* Größe des "X" */
  cursor: pointer;   /* Zeigt den Mauszeiger als Hand, wenn Sie darüber fahren */
}

/* Stile für größere Bildschirme */
@media (min-width: 768px) {
  .usp {
    gap: 120px;
  }
}

/* Stile für kleinere Bildschirme (Mobile) */
@media (max-width: 767px) {
  .bg-container {
    padding: 20px 15px; /* Erhöhtes Padding, insbesondere seitlich */
  }

  .primary-text {
    font-size: 18px;  /* Weiter reduzierte Schriftgröße */
    margin-bottom: 10px;
  }

  h2 {
    font-size: 14px;  /* Weiter reduzierte Schriftgröße für den Untertitel */
    margin-top: 10px;
    line-height: 1.4; /* Erhöhte Zeilenhöhe für bessere Lesbarkeit */
  }

  .usp {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .usp-icon {
    width: 35px;
    margin-bottom: 5px;
  }

  .usp-text {
    font-size: 0.9rem;
    margin-bottom: 3px;
  }

  .usp-subtext {
    font-size: 0.8rem;
  }

  .content-container .elevation-0 {
    width: 90%;
    margin: 10px 5%;
    height: auto;
    font-size: 16px;  /* Weiter reduzierte Schriftgröße */
  }

  .content-container mdi-thumb-up, .content-container mdi-thumb-down {
    font-size: 30px;
  }
}


</style>
